import { useFetch } from "~vue/api";
import { logError, logUserInteraction } from "~vue/utils/logUtils";
import { computed, ref } from "vue";

const V1_URL = (hashid) => `/accounts/coaching_session/${hashid}`;

/**
 * Composable to rename a past conversation.
 *
 * @param {Object} args
 * @param {Function} args.onResponseCallback - Called after a successful rename.
 * @param {string} args.source - Source identifier, used for analytics.
 */
export const useRenamePastConversation = ({ onResponseCallback, source }) => {
    const activeUrl = ref(null);
    const payload = ref(null);
    const url = computed(() => activeUrl.value);

    const postFetch = useFetch(url, { immediate: false }).post(computed(() => payload.value));

    const renamePastConversation = async ({ kind, hashid, uuid, newTitle }) => {
        payload.value = { title: newTitle };
        logUserInteraction("rename_conversation", { kind, hashid, uuid, ...(source && { source }) }, uuid);

        const fetcher = postFetch;
        activeUrl.value = V1_URL(hashid);

        await fetcher.execute();

        if (fetcher.error.value) {
            logError(fetcher.error.value);
        } else {
            onResponseCallback?.();
        }
    };

    return {
        renamePastConversation,
    };
};
